export const LinkedinIcon = ({ color = '#c2ccdd' }) => {
	return (
		<svg
			fill={color}
			height='25'
			viewBox='0 0 24 25'
			width='24'
			xmlns='http://www.w3.org/2000/svg'>
			<path d='M22.2234.367188H1.77187C.792187.367188 0 1.14063 0 2.09688v20.53592c0 .9563.792187 1.7344 1.77187 1.7344h20.45153c.9797 0 1.7766-.7781 1.7766-1.7297V2.09688c0-.95625-.7969-1.729692-1.7766-1.729692zM7.12031 20.8187H3.55781v-11.4562H7.12031zm-1.78125-13.01714c-1.14375 0-2.06718-.92344-2.06718-2.0625s.92343-2.0625 2.06718-2.0625c1.13907 0 2.0625.92344 2.0625 2.0625 0 1.13438-.92343 2.0625-2.0625 2.0625zm15.11254 13.01714h-3.5579v-5.5687c0-1.3266-.0234-3.0375-1.8515-3.0375-1.8516 0-2.1328 1.4484-2.1328 2.9437v5.6625h-3.55315v-11.4562h3.41245v1.5656h.0469c.4735-.9 1.636-1.85154 3.3657-1.85154 3.6046 0 4.2703 2.37184 4.2703 5.45624z' />
		</svg>
	);
};
